import { render, staticRenderFns } from "./ArtifactVersion.vue?vue&type=template&id=2d207189&scoped=true"
import script from "./ArtifactVersion.vue?vue&type=script&lang=js"
export * from "./ArtifactVersion.vue?vue&type=script&lang=js"
import style0 from "./ArtifactVersion.vue?vue&type=style&index=0&id=2d207189&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d207189",
  null
  
)

export default component.exports